import React, { useState } from "react";
import cx from "classnames";
import "./SegmentedSelect.scss";
import { motion } from "framer-motion";
export function SegmentedSelect({ alternatives, value, onChange, "data-test-id-partial": dataTestIdPartial, }) {
    const [inputName] = useState("segment_" + Math.random().toString(36).substr(2, 9));
    const selectedIdx = alternatives.findIndex((alternative) => alternative.value === (value === null || value === void 0 ? void 0 : value.value));
    return (React.createElement("div", { className: "lysa-ui-segmented" }, alternatives.map((alternative, idx) => {
        const itemId = `${inputName}_${alternative.value}_${alternative.text}`;
        const itemClasses = cx("item", { selected: selectedIdx === idx });
        const dataTestId = dataTestIdPartial !== undefined
            ? dataTestIdPartial + "-" + alternative.value
            : undefined;
        return (React.createElement("div", { className: itemClasses, key: `${alternative.text}-${alternative.value}` },
            React.createElement("input", { type: "radio", id: itemId, name: inputName, checked: idx === selectedIdx, onChange: () => onChange(alternative) }),
            React.createElement("label", { htmlFor: itemId, "data-test-id": dataTestId }, alternative.text),
            selectedIdx === idx && (React.createElement(motion.div, { className: "overlay", layoutId: "overlay", initial: false }, alternative.text))));
    })));
}
